import axios from '@/utils/request';

const v1 = 'v1/admin/users';

export function login(data) {
  return axios({
    url: '/auth/login',
    method: 'post',
    data,
  });
}

export function getInfo(token) {
  return axios({
    url: 'auth/user/info',
    method: 'get',
  });
}

export function logout() {
  return axios({
    url: 'auth/signout',
    method: 'post',
  });
}

export const getUsers = ({ company_id }) => axios.get(`${v1}/index`, { params: { company_id } });
export const updateUser = (data) => axios.post(`${v1}/user/update`, data);
export const deleteUser = (id) => axios.delete(`${v1}/user/${id}`);
export const getRoles = () => axios.get(`${v1}/roles`);
export const getRole = (id) => axios.get(`${v1}/role/${id}`);
export const updateRole = (data, id) => axios.post(`${v1}/role/${id ?? ''}`, data);
export const deleteRole = (id) => axios.delete(`${v1}/role/${id}`);

export const getUserRoles = (id) => axios.get(`${v1}/${id}/roles`);
export const getRolesWithPermissions = () => axios.get(`${v1}/roles/permissions`);

export const syncPermissions = (data) => axios.post(`${v1}/permission/sync`, data);

export const getUserHasReplenish = ({ company_id }) => axios.get(`${v1}/userHasReplenish`, { params: { company_id } });

const permitApi = 'v1/admin/permission';

export const getRolesV2 = ({ label = '1' }) => axios.get(`${permitApi}/roles`, { params: { label } });
export const getRoleV2 = (id) => axios.get(`${permitApi}/role`, { params: { id } });

export const updateRoleV2 = (data) => axios.post(`${permitApi}/role/update`, data);
export const createRoleV2 = (data) => axios.post(`${permitApi}/role/create`, data);

export const deleteRoleV2 = ({ id }) => axios.post(`${permitApi}/role/delete`, { id });

export const createUserV2 = (data) => axios.post(`${permitApi}/user/create`, data);

export const updateUserV2 = (data) => axios.post(`${permitApi}/user/update`, data);

export const deleteUserV2 = (id) => axios.post(`${permitApi}/user/delete`, { id });

export const userStatus = ({ id, status }) => axios.post(`${permitApi}/user/status`, { id, status });
